// extracted by mini-css-extract-plugin
export default {"overview__container":"GeometryOverview_overview__container__bCbyb"};